import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GeneralDrawerSliceinitialStateInterface } from "../../types/reduxSlices";

const initialState: GeneralDrawerSliceinitialStateInterface = {
  showGeneralDrawer: false,
  selectedFilter: null,
  resultCount: 0,
  drawerKey: "",
};

const generalDrawerSlice = createSlice({
  name: "generalDrawer",
  initialState,
  reducers: {
    handleshowGeneralDrawer: (
      state,
      action: PayloadAction<
        Partial<{
          showGeneralDrawer: boolean;
          SelectedFilter: any;
          resultCount: number;
          drawerKey: string;
        }>
      >,
    ) => {
      const { showGeneralDrawer, SelectedFilter, resultCount, drawerKey } =
        action.payload;
      if (showGeneralDrawer !== undefined && showGeneralDrawer !== null) {
        state.showGeneralDrawer = showGeneralDrawer;
      }
      if (resultCount !== undefined && resultCount !== null) {
        state.resultCount = resultCount;
      }
      if (SelectedFilter !== undefined && SelectedFilter !== null) {
        state.selectedFilter = SelectedFilter;
      }
      if (drawerKey !== undefined && drawerKey !== null) {
        state.drawerKey = drawerKey;
      }
    },
  },
});

export const { handleshowGeneralDrawer } = generalDrawerSlice.actions;

export default generalDrawerSlice.reducer;
